var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"custom-button",attrs:{"color":"#635dff"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('span',{staticClass:"button-text"},[_vm._v(_vm._s(_vm.text))]),_c('v-img',{staticClass:"custom-icon",attrs:{"src":_vm.iconSrc}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }